// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2eEQV","buttons":"SendReceipts_buttons__1mPIV","email":"SendReceipts_email__NHJSb","bookApptTitle":"SendReceipts_bookApptTitle__3DESf"};